import React, { useState } from 'react'
import PerformanceDashFilters from './PerformanceDashFilters'
import { useSelector } from 'react-redux'
import { Radio } from 'antd'
import { Bar, BarChart, CartesianGrid, Cell, LabelList, Legend, Pie, PieChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'
import ASMSkeleton from './skeletons/ASMSkeleton'

const PIE_CHART_COLORS = [
    "#5D5FEF", "#7667b4", "#695398", "#a063b0", "#c352b0", "#cd358b", "#f73f86", "#e15e67",
    "#ff0000", "#ff4800", "#ff9300", "#ffb11f", "#f6f600", "#d6e414", "#7acf47", "#00bc50",
    "#00984c", "#007543", "#00c8be", "#49c5ed", "#399dda"
];
const PRIMARY_FILTERS = [
    {
        entity: "site",
        key: "group1",
        value: "Client Type"
    },
    {
        entity: "pan_asm_dashboard",
        key: "region",
        value: "Region"
    },
    {
        entity: "site",
        key: "udf4",
        value: "Sales ASM"
    },
    {
        entity: "generic_item_master_report",
        key: "hl1_name",
        value: "Product Category"
    }
]
const DATA_TYPE_MAP = {
    salesQty: "Sales Quantity",
    salesValue: "Sales Value"
}
const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent }) => {
    const RADIAN = Math.PI / 180;
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
        <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
            {`${(percent * 100).toFixed(0)}%`}
        </text>
    );
};
const currentFilterKeys = ['group1', 'region', 'udf4', 'hl1_name']

const AsmYtd = (props) => {
    const { dashboardData } = props
    const digivendStore = useSelector(state => state.digivendStore)
    const [dataType, setDataType] = useState('salesQty')

    // function to get the dashboard data
    const getDashboardData = (filtersData = {}) => {
        props.getDashboardData(filtersData)

    }

    const WrappedLegend = ({ payload }) => {
        return (
            <div style={{
            display: "flex",
            flexDirection: 'column',
            flexWrap: "wrap",
            gap: "8px 16px",
            maxWidth: "100%",
            maxHeight: "500px",
            padding: "10px 0"
            }}>
            {payload.map((entry, index) => (
                <div key={`legend-${index}`} style={{ display: "flex", alignItems: "center" }}>
                <div
                    style={{
                    width: 12,
                    height: 12,
                    backgroundColor: entry.color || 'black',
                    marginRight: 6,
                    borderRadius: 2
                    }}
                />
                <span style={{ color: entry.color || 'black', fontSize: 12 }}>
                    {entry.value}
                </span>
                </div>
            ))}
            </div>
        );
    };

    const getMaxLabelWidth = (data, key, font = "10px sans-serif") => {
        if (!data || !data.length) return 120;

        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        context.font = font;

        let maxWidth = 0;

        data.forEach((item) => {
            const text = item[key] || "";
            const width = context.measureText(text).width;
            if (width > maxWidth) {
            maxWidth = width;
            }
        });

        // add some padding (important)
        return Math.ceil(maxWidth) + 20;
    };

    const yAxisWidth = getMaxLabelWidth(
    dashboardData?.regionWiseSectionContriPer,
    "region",
    "10px sans-serif"
    );

    return (
        <div className='asm-ytd'>
            <PerformanceDashFilters
                PRIMARY_FILTERS={PRIMARY_FILTERS}
                applyFilter={getDashboardData}
                currentFilterKeys={currentFilterKeys}
            />
            <div className="psp-radio ">
                <h1>Data Type</h1>
                <Radio.Group value={dataType} onChange={(e) => setDataType(e?.target?.value || "")}>
                    <Radio.Button value={"salesQty"}>Sales Quantity</Radio.Button>
                    <Radio.Button value={"salesValue"}>Sales Vaue</Radio.Button>
                </Radio.Group>
            </div>

            {/* graph data */}
            {digivendStore?.getARSDashboardDataData?.isLoading ? (<ASMSkeleton />) :
                (<div role="tabpanel" className="tab-pane fade" id="asm">
                    <div className="flex p-top-20 p-lr-12">
                        <div className='grid w-50 p-rgt-12'>
                            <div className="store-analytics-table-head">
                                <div className="sath-left">
                                    <h3>Month-wise {DATA_TYPE_MAP?.[dataType]}</h3>
                                </div>
                            </div>
                            <div className="store-analytics-table-body ars-graph-box">
                                {dashboardData?.monthWiseSales &&
                                    <ResponsiveContainer width="100%" height={400}>
                                        <BarChart data={dashboardData?.monthWiseSales}>
                                            <XAxis dataKey="month" padding={{ left: 25, right: 25 }} />
                                            <YAxis type="number" />
                                            <CartesianGrid strokeDasharray="2" />
                                            <Legend align="right" verticalAlign="top" />
                                            <Tooltip overlayClassName='!p-[0]' labelStyle={{ color: "#94a5c6", fontWeight: 500 }} contentStyle={{ color: "#12203c", fontWeight: 600 }} />
                                            <Bar name={DATA_TYPE_MAP?.[dataType]} dataKey={dataType} fill={PIE_CHART_COLORS[0]}>
                                                <LabelList dataKey={dataType} position="top" />
                                            </Bar>
                                        </BarChart>
                                    </ResponsiveContainer>}
                            </div>
                        </div>
                        <div className="grid w-50 p-rgt-12">
                            <div className="store-analytics-table-head">
                                <div className="sath-left">
                                    <h3>Region-wise Store Grade Contribution %</h3>
                                </div>
                            </div>
                            <div className="store-analytics-table-body ars-graph-box">
                                {dashboardData?.storeGradeContriPer &&
                                    <ResponsiveContainer width="100%" height={400}>
                                        <PieChart>
                                            <Pie data={dashboardData?.storeGradeContriPer} cx="50%" cy="50%" dataKey="total" nameKey="grade" name="Total Contribution" innerRadius={80} labelLine={false} label={renderCustomizedLabel}>
                                                {dashboardData?.storeGradeContriPer?.map((item, index) => (
                                                    <Cell name={item?.["grade"] || ""} key={item?.grade} fill={PIE_CHART_COLORS?.[index]} />
                                                ))}
                                            </Pie>
                                            <Legend align="right" verticalAlign="middle" layout="vertical" />
                                            <Tooltip />
                                        </PieChart>
                                    </ResponsiveContainer>}
                            </div>
                        </div>
                    </div>
                    <div className="flex p-top-20 p-lr-12">
                        <div className="grid w-50 p-rgt-12">
                            <div className="store-analytics-table-head">
                                <div className="sath-left">
                                    <h3>Region-wise Section Contribution %</h3>
                                </div>
                            </div>
                            {console.log('dashboardData?.regionWiseSectionContriPer', dashboardData?.regionWiseSectionContriPer)}
                            <div className="store-analytics-table-body ars-graph-box">
                                {dashboardData?.regionWiseSectionContriPer &&
                                    // <ResponsiveContainer width="100%" height={400}>
                                    //     <BarChart layout="vertical" data={dashboardData?.regionWiseSectionContriPer} stackOffset="expand">
                                    //         <XAxis type="number" hide={true} />
                                    //         <YAxis type="category" dataKey="region" />
                                    //         <CartesianGrid strokeDasharray="2" />
                                    //         <Legend align="right" verticalAlign="top" />
                                    //         <Tooltip />
                                    //         {Object.keys(dashboardData?.regionWiseSectionContriPer && dashboardData?.regionWiseSectionContriPer?.length > 0 && dashboardData?.regionWiseSectionContriPer?.[0])?.map((key, index) => key !== "region" &&
                                    //             <Bar dataKey={key} fill={PIE_CHART_COLORS[index]} stroke="#FFFFFF" stackId="section" />
                                    //         )}
                                    //     </BarChart>
                                    // </ResponsiveContainer>
                                    <ResponsiveContainer width="100%" height={dashboardData?.regionWiseSectionContriPer?.length > 40 ? 700 : dashboardData?.regionWiseSectionContriPer?.length > 20 ? 600 : 400}>
                                    <BarChart
                                        layout="vertical"
                                        data={dashboardData?.regionWiseSectionContriPer}
                                        stackOffset="expand"
                                        margin={{ left: 20, right: 20 }} // 👈 key change
                                    >
                                        <XAxis type="number" hide={true} />
                                        
                                        <YAxis
                                        type="category"
                                        dataKey="region"
                                        width={yAxisWidth}
                                        tick={({ x, y, payload }) => 
                                            (
                                            <text
                                                x={x}
                                                y={y}
                                                dy={4}
                                                textAnchor="end"
                                                style={{
                                                    whiteSpace: "nowrap", // 👈 force single line
                                                    fontSize: 10,
                                                    fill: "#666"
                                                }}
                                            >
                                                {payload?.value}
                                            </text>
                                            )
                                        }
                                        />

                                        <CartesianGrid strokeDasharray="2" />
                                        <Legend align="right" verticalAlign="top" />
                                        <Tooltip />

                                        {Object.keys(
                                        dashboardData?.regionWiseSectionContriPer?.[0] || {}
                                        ).map(
                                        (key, index) =>
                                            key !== "region" && (
                                            <Bar
                                                key={key}
                                                dataKey={key}
                                                fill={PIE_CHART_COLORS[index]}
                                                stroke="#FFFFFF"
                                                stackId="section"
                                            />
                                            )
                                        )}
                                    </BarChart>
                                    </ResponsiveContainer>
                                    }
                            </div>
                        </div>
                        <div className="grid w-50 p-rgt-12">
                            <div className="store-analytics-table-head">
                                <div className="sath-left">
                                    <h3>Month-wise Full Price & Discounted Sales Breakup</h3>
                                </div>
                            </div>
                            <div className="store-analytics-table-body ars-graph-box">
                                {dashboardData?.monthWisePriceTypeSales &&
                                    <ResponsiveContainer width="100%" height={400}>
                                        <BarChart data={dashboardData?.monthWisePriceTypeSales} stackOffset="expand">
                                            <XAxis dataKey="month" padding={{ left: 25, right: 25 }} />
                                            <YAxis type="number" hide={true} />
                                            <CartesianGrid strokeDasharray="2" />
                                            <Legend align="right" verticalAlign="top" />
                                            <Tooltip />
                                            <Bar name="Full Price" dataKey="full" fill={PIE_CHART_COLORS[0]} stroke="#FFFFFF" stackId="priceType">
                                                <LabelList dataKey="full" position="center" />
                                            </Bar>
                                            <Bar name="Discounted Price" dataKey="discounted" fill={PIE_CHART_COLORS[7]} stroke="#FFFFFF" stackId="priceType">
                                                <LabelList dataKey="discounted" position="center" />
                                            </Bar>
                                        </BarChart>
                                    </ResponsiveContainer>}
                            </div>
                        </div>
                    </div>
                    <div className="p-lr-12 m-top-30">
                        <div className="store-analytics-table-head">
                            <div className="sath-left">
                                <h3>Department-wise ASM Contribution %</h3>
                            </div>
                        </div>
                        <div className="store-analytics-table-body ars-graph-box">
                            {console.log("PORT1", dashboardData?.depWiseASMContriPer)}
                            {dashboardData.depWiseASMContriPer &&
                                <ResponsiveContainer width="100%" height={500}>
                                    <PieChart>
                                        <Pie 
                                            data={dashboardData?.depWiseASMContriPer} 
                                            cx="50%" 
                                            cy="50%" 
                                            dataKey="contri" 
                                            nameKey="dep" 
                                            name="Total Contribution" 
                                            innerRadius={80} 
                                            // label
                                            >
                                            {dashboardData?.depWiseASMContriPer?.map((item, index) => (
                                                <Cell name={item?.dep || ""} key={item?.grade} fill={PIE_CHART_COLORS?.[index]} />
                                            ))}
                                        </Pie>
                                        <Legend align="right" verticalAlign="middle" layout="vertical" content={<WrappedLegend />}  />
                                        <Tooltip />
                                    </PieChart>
                                </ResponsiveContainer>}
                        </div>
                    </div>
                </div>
                )}
        </div>

    )
}

export default AsmYtd